import Listar from '@/views/Analises/Listar'
import ListarDocumentos from '@/views/Analises/Documentos/ListarDocumentos'
import Form from '@/views/Analises/Form'
import DigitarResultado from '@/views/Analises/DigitarResultado'
import Detalhes from '@/views/Analises/Detalhes'
import Agrupamento from '@/views/Analises/Agrupamento'
import ListagemEnviosEmbrapa from '@/views/Analises/ListagemEnviosEmbrapa'

const routes = [
    {
        meta: {auth: true},
        path: '/analises',
        name: 'analises',
        component: Listar
    },

    {
        meta: {auth: true},
        path: '/analises/documentos',
        name: 'analises.documentos',
        component: ListarDocumentos
    },


    {
        meta: {auth: true},
        path: '/analises/adicionar',
        name: 'analises.adicionar',
        component: Form
    },

    {
        meta: {auth: true},
        path: '/analises/editar/:id',
        name: 'analises.editar',
        component: Form
    },

    {
        meta: {auth: true},
        path: '/analises/resultado',
        name: 'analises.resultado',
        component: DigitarResultado
    },
    {
        meta: {auth: true},
        path: '/detalhes/:id',
        name: 'analises.detalhes',
        component: Detalhes
    },
    {
        meta: {auth: true},
        path: '/agrupamento',
        name: 'analises.agrupar',
        component: Agrupamento
    },
    {
        meta: {auth: true},
        path: '/embrapa',
        name: 'envios.embrapa',
        component: ListagemEnviosEmbrapa
    },


]
export default routes
